export const RESET_CURRENT_IMAGE = 'RESET_CURRENT_IMAGE';
export const SET_CURRENT_IMAGE = 'SET_CURRENT_IMAGE';
export const SET_PRODUCT_NAV = 'SET_PRODUCT_NAV';
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_PRODUCT_CAROUSELS = 'SET_PRODUCT_CAROUSELS';
export const SET_PRODUCT_IMAGES = 'SET_PRODUCT_IMAGES';
export const RESET_PRODUCT = 'RESET_PRODUCT';